<template>
  <button
    class="ds-menu-item"
    :class="`ds-menu-item--${variant}`"
    type="button"
    @click="emit('click', $event)"
  >
    <i
      v-if="icon && !isImageIcon"
      :class="icon"
      class="ds-menu-item__icon ds-menu-item__icon--font"
      aria-hidden="true"
    />
    <img
      v-else-if="icon"
      :src="icon"
      alt=""
      aria-hidden="true"
      class="ds-menu-item__icon ds-menu-item__icon--image"
    />
    <span class="ds-menu-item__label">{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  icon?: string
  label: string
  variant?: 'default' | 'danger'
}

const props = withDefaults(defineProps<Props>(), {
  icon: undefined,
  variant: 'default'
})

const emit = defineEmits<{ click: [event: MouseEvent] }>()
const isImageIcon = computed(() => !!props.icon && /\.(svg|png|jpe?g|webp|gif)$/i.test(props.icon))
</script>

<style scoped>
.ds-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  padding: 10px 8px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.ds-menu-item:hover {
  background-color: var(--ds-purple-50);
}

.ds-menu-item__icon {
  width: 18px;
  min-width: 18px;
  text-align: center;
  color: var(--ds-purple-main);
}

.ds-menu-item__icon--image {
  object-fit: contain;
}

.ds-menu-item--danger {
  color: #D13237;
}

.ds-menu-item--danger .ds-menu-item__icon {
  color: #D13237;
}
</style>
